export class LoadingCoverComponent {
    constructor(private element: HTMLElement) {}

    setVisibility(toggle: boolean) {
        $(this.element).toggleClass("loading-cover--visible", toggle);
    }
}